<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="申请人信息：" prop="applyInfo">
            <el-input v-model="query.applyInfo" placeholder="请输入姓名/手机号" size="small" clearable/>
          </el-form-item>
          <el-form-item label="申请人身份：">
            <el-select v-model="query.applyLevel" placeholder="请选择" clearable size="small" @change="handleTechnical">
              <el-option v-for="(item,index) in options.businessStanding" :key="item.id" :label="item.name"
                :value="item.level"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请类型：">
            <el-select v-model="query.processingType" placeholder="请选择" clearable size="small">
              <el-option label="招募业务员" :value="1"></el-option>
              <el-option label="修改业务员" :value="3"></el-option>
              <el-option label="业务员离职" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核人信息：">
            <el-input v-model="query.auditInfo" placeholder="请输入姓名/手机号" size="small" clearable/>
          </el-form-item>
          <el-form-item label="审核人身份：">
            <el-select v-model="query.auditLevel" placeholder="请选择" clearable size="small" @change="handleTechnical">
              <el-option v-for="(item,index) in options.businessStanding" :key="item.id" :label="item.name"
                :value="item.level"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" clearable>
              <el-option label="提交时间" :value="1"></el-option>
              <el-option label="抄送时间" :value="2"></el-option>
              <el-option label="同意时间" :value="3"></el-option>
              <el-option label="驳回时间" :value="4"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo: 1})">
          <el-tab-pane label="待审核" name="1"></el-tab-pane>
          <el-tab-pane label="同意申请" name="2"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="3"></el-tab-pane>
        </el-tabs>
        <!-- <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
        </div> -->
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column label="审批编号" prop="name" align="center" width="160" fixed>
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary">{{row.approvalNumber}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请人信息" prop="orderNo" align="center" width="200" fixed>
          <template slot-scope="{row}">
            {{row.submitName}}<br />
            {{row.submitPho}}
          </template>
        </el-table-column>
        <el-table-column label="申请人身份" prop="levelName" align="center" />
        <el-table-column label="申请类型" prop="submitLevel" align="center">
          <template slot-scope="{row}">
            {{row.processingType | setState}}
          </template>
        </el-table-column>
        <el-table-column label="申请内容" prop="remark" align="center" width="140">
          <template slot-scope="{row}">
            <div v-if="row.processingType==3">
              <span>原身份：{{row.oldLevelName}}</span>
              <span>调整身份：{{row.sjLevelName}}</span>
            </div>
            <div v-else>
              <span v-if="row.processingType==4">将</span><span>{{row.customerName}}</span>({{row.processingType==1?row.sjLevelName:row.oldLevelName}})<span v-if="row.processingType==4">{{row.customerPho}}</span><br />
              <span v-if="row.processingType==1">{{row.customerPho}}</span><span v-if="row.processingType==4">调为离职</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核人信息" prop="orderNo" align="center" width="200" v-if="activeName!='1'">
          <template slot-scope="{row}">
            {{row.auditName}}<br />
            {{row.auditPho}}
          </template>
        </el-table-column>
        <el-table-column label="审核人身份" prop="auditLevelName" align="center" v-if="activeName!='1'" />
        <el-table-column label="提交时间" prop="submitTime" sortable align="center" width="200"  v-if="['1','2','3'].includes(activeName)"/>
        <el-table-column label="同意时间" prop="auditTime" sortable align="center" width="200"
          v-if="activeName=='2'" />
        <el-table-column label="抄送时间" prop="submitTime" sortable align="center" width="200"
          v-if="activeName=='2'" />
        <el-table-column label="驳回时间" prop="auditTime" sortable align="center" width="200"
          v-if="activeName=='3'" />
        <el-table-column label="驳回原因" prop="rejectCause" sortable align="center" width="200"
          v-if="activeName=='3'" />
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
  import businessProcessingApi from '@/api/user/businessProcessing'
  import Pagination from '@/components/Pagination'
  import customerLevelApi from '@/api/sys/customerLevel'
  export default {
    components: {
      Pagination,
      // businessQuit,
      // businessAdjust,
      // areaRemove
    },
    data() {
      return {
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          // customerType: 2
        },
        cascaderProps: {
          label: 'areaName',
          value: 'areaCode',
          children: 'child',
        },
        selectItems: [],
        activeName: '1',
        standingList: [],
        discountList: [],
        configList: [],
        labelList: [],
        technicianList: [],
        options: {
          businessStanding: [],
          identityOptions: []
        },
        popType: 0,
        addressList: [],
        dateTime: null
      }
    },
    filters: {
      setState(val) {
        switch (val) {
          case 1:
            return "招募业务员";
          case 3:
            return "修改业务员";
          case 4:
            return "业务员离职";
          default:
            return val;
        }
      }
    },
    created() {
      this.doQueryList({
        pageNo: 1
      })
      this.getBusinessStanding()
      // this.getDiscountList()
      // this.getLabelList()
      // this.getAddressList()
      // this.getTechnicianList()
    },
    methods: {
      handleFilter() {
        this.query = {
          pageNo: 1,
          pageSize: 10
        }
        this.dateTime = []
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 执行列表查询
       */
      doQueryList({
        pageNo,
        pageSize
      }) {
        // this.query.isDeparted = this.activeName * 1
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        let query = {
          ...this.query,
          processingStatus: this.activeName
        }
        if([2,3,4].includes(this.query.timeType)){
          query.timeType=2
        }
        if (this.query.timeType && this.dateTime && this.dateTime.length) {
          query.startTime = this.dateTime[0]
          query.endTime = this.dateTime[1]
        }
        if (this.dateTime && this.dateTime.length && !this.query.timeType) {
          this.dateTime = null
        }
        // this.query.displayPosition=this.activeName
        this.listLoading = true
        return businessProcessingApi.fetchList(query)
          .then(({
            data
          }) => {
            console.log("data: ", data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      // 获取业务员身份
      getBusinessStanding() {
        customerLevelApi.fetchList({
          type: 2
        }).then(({
          data
        }) => {
          this.options.businessStanding = data
          console.log('客户身份: ', data);
        })
      },
      // 获取系统配置
      getConfig() {
        sysDataconstantApi.fetchBatchCode({
          code: 'shopType,dayAVGOutpatients,employeeNums,carryProjects'
        }).then(({
          data
        }) => {
          this.configList = data.list
          // console.log("配置: ", data);
        })
      },
      /**
       * 打开新建表单
       */
      handleCreate() {
        this.popType = 0
        this.$refs.businessAdd.handleCreate()
      },
      /**
       * 打开查看表单
       */
      handleShow(row) {
        console.log('row: ',row);
        this.$emit('handleShow', row.id, 2)
      },
    }
  }
</script>
